import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FileUploadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"file_upload"}/>
}
